import React from 'react';

export default function SidePanel({ children, isActive }) {
  return (
    <div
      data-component-name='SidePanel'
      className={`sm:max-w-[360px] w-full h-full shadow-md px-8 pt-7 pb-7 absolute right-0 top-0 transition-all duration-500 bg-white-400 ${
        isActive === true ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
      }`}
    >
      {children}
    </div>
  );
}
